export default __webpack_public_path__ + "static/media/17_LeftToRightSquares_RotateLeft.14882d22.mp4";